export default __webpack_public_path__ + "static/media/loja4.da971a32.jpeg";